// src/store.js (Vue CLI 1.x & 2.x) oder src/store/index.js (Vue CLI 3.x or newer)
// import axios from 'axios';
import 'es6-promise/auto'
import createPersistedState from 'vuex-persistedstate';
import { createStore } from 'vuex'


  
// Create a new store instance.
export const store = createStore({
    strict: true,
    plugins: [createPersistedState()],
    state: {
        user : {
          company: "",
          admin: ""
        }
      },
    getters: {
      getUser: state => {
        return state.user
      }
    },
    mutations: {
      setUser (state, user) {
        state.user = {
          company: user[0].company,
          admin: user[0].admin
        }
      },
      logout (state) {
        state.user = ""
      }
    },
    actions: {
      setUser (context, user) {
        context.commit('setUser', user)
      },
      logout (context) {
        context.commit('logout')
      }
    }
  })
